import React from 'react';
import { components } from 'react-select';
import { Lock } from 'components/SvgIcons';
import { CFM_METAL } from 'constants/Colors';

export default (props) => {
    const className = `${props.className} fm-select__indicator-search`;
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props} className={className}>
                <Lock color={CFM_METAL} />
            </components.DropdownIndicator>
        )
    );
};
